import React, { useState } from 'react';
import MediaViewerModal from './MediaViewerModal';

export const useMediaViewer = () => {
    const [modalState, setModalState] = useState({ isOpen: false, url: '', typeHint: '' });

    const openMedia = (url, typeHint = '') => {
        if (!url) return;

        const lowerUrl = url.toLowerCase();
        const lowerHint = (typeof typeHint === 'string' ? typeHint : '').toLowerCase();
        const isPdf = lowerUrl.includes('.pdf') || lowerUrl.includes('application/pdf') || lowerUrl.includes('data:application/pdf') || lowerHint.includes('pdf');

        if (isPdf) {
            window.open(url, '_blank', 'noopener,noreferrer');
            return;
        }

        setModalState({ isOpen: true, url, typeHint });
    };

    const closeMedia = () => {
        setModalState({ isOpen: false, url: '', typeHint: '' });
    };

    const MediaViewer = (
        <MediaViewerModal 
            isOpen={modalState.isOpen} 
            mediaUrl={modalState.url}
            typeHint={modalState.typeHint} 
            onClose={closeMedia} 
        />
    );

    return { openMedia, MediaViewer };
};
